import Embed from 'quill/blots/embed';
import {getAvatarUrlFromId} from "../../../../helpers/getFileUrlFromId";
import Avatar from "../../../../assets/avatar.svg"

export interface MentionData {
    id: string;
    photoId: string;
    surname: string;
}

class MentionBlot extends Embed {
    static blotName = 'mention';
    static tagName = 'div';
    static className = 'mention-custom';

    static create(data: MentionData) {
        const node = super.create() as HTMLElement;
        node.innerHTML = `
            <img data-key="${data.photoId}"
                src="${getAvatarUrlFromId(Number(data.id))}"
                onerror="this.onerror=null; this.src='${Avatar}'"/>
            <a href="#" data-id="${data.id}">${data.surname}</a>
        `;

        return node;
    }

    static value(node: HTMLElement): MentionData {
        const a = node.querySelector('a');
        const img = node.querySelector('img');

        if (!a && !img) {
            return { id: '', photoId: '', surname: '' };
        }

        // const [username, surname] = a!.textContent?.split(' ') || ['', ''];
        
        return {
            id: a!.getAttribute('data-id') || '',
            photoId: img!.getAttribute('data-key') || '',
            surname: a!.textContent ?? ""
        };
    }
}

export default MentionBlot;